module.exports = __webpack_public_path__ + "static/media/monkey_king.fffd0f31.png";